<div class="field-wrapper">
  <div class="input-wrapper">
    <label [for]="name">{{ label | translate }}</label>
    <input [name]="name"
           [id]="inputId"
           [placeholder]="placeholder"
           [type]="type"
           [autocomplete]="autocomplete"
           (keydown)="checkInputValue($any($event))"
           [autofocus]="autofocus"
           (paste)="checkInputValue($any($event))"
           [(ngModel)]="value"
           #input>
          </div>
    <button *ngIf="showPasswordButton"
            type="button"
            class="password-button"
            [ngClass]="type"
            (click)="toggleInputType(input)"></button>
</div>
